import { render, staticRenderFns } from "./Template4.vue?vue&type=template&id=b1f8c814&scoped=true&"
import script from "./Template4.vue?vue&type=script&lang=js&"
export * from "./Template4.vue?vue&type=script&lang=js&"
import style0 from "./Template4.vue?vue&type=style&index=0&id=b1f8c814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f8c814",
  null
  
)

export default component.exports